import React from 'react';
import Table from '../../component/table/table'
import { BASE_END_POINT } from '../../urls'
import axios from 'axios'
import Button from '@material-ui/core/Button';
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import './clients.css'
import { message, TreeSelect, DatePicker, ConfigProvider } from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import { withRouter, Redirect, NavLink } from 'react-router-dom'
import { ChangeLanguage } from '../../redux/actions/LanguageAction'
import { CSVLink } from "react-csv";
import { SearchOutlined } from '@ant-design/icons';
import moment from 'moment'
import locale_ar from 'antd/lib/locale/ar_EG';
import locale_en from 'antd/lib/locale/en_GB';
import 'moment/locale/ar';
import PaginationButtons from '../../component/pagenation/pagenation';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
const { TreeNode } = TreeSelect;
const { SHOW_PARENT } = TreeSelect;
const { RangePicker } = DatePicker;
let headers = [
  { label: "#", key: "id" },
  { label: "الاسم", key: "clientName" },
  { label: "رقم الهاتف", key: "clientPhone" },
  { label: "الدوله", key: "clientCountry" },
  { label: "المسوق", key: "user" },
  { label: "المدينه", key: "city" },
  { label: "الحى", key: "area" },
  { label: "القسم الرئيسى", key: "category" },
  { label: "القسم الفرعى", key: "subCategory" },
  { label: "نوع التعاقد", key: "contractType" },
  { label: "التاريخ", key: "date" },
];

let csvData = [

];
class clients extends React.Component {

  state = {
    clients: [],
    clients2: [],
    csvData: [],
    loading: true,
    refresh: false,
    page: 1,
    pages: 1,
    collapsed: false,
    user: this.props.location.state ? this.props.location.state.owner ? this.props.location.state.owner : null : null,
    isLocked: this.props.location.state ? this.props.location.state.isLocked : false,
    countries: [],
    count: 0,
    cities: [],
    areas: [],
    categories: [],
    subCategories: [],
    area: null,
    city: null,
    country: null,
    category: null,
    subCategory: null,
    status: null,
    contractType: null,
    showFilter: false,
    startDate: null,
    endDate: null,
    search: null,
    isReady: false,
    buildCsv: false,
    lockedBy: null,
    users: []
  }

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    console.log('props', props)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    let pageNum = this.state.page
    if (sessionStorage.getItem('pageName') === "CLIENTS") {
      pageNum = sessionStorage.getItem('pageNum');
      this.setState({ page: pageNum })
    }
    this.getClients(pageNum, false)
    this.getCategory()
    this.getCountries()
    this.getUserWithoutPagenation()
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      const user = this.props.location.state ? (this.props.location.state.owner ? this.props.location.state.owner : null) : null;
      const isLocked = this.props.location.state ? this.props.location.state.isLocked : false;
      this.setState({
        page: 1,
        user: user,
        isLocked: isLocked,
        area: null,
        city: null,
        country: null,
        category: null,
        subCategory: null,
        status: null,
        contractType: null,
        startDate: null,
        endDate: null,
        search: null,
        buildCsv: false,
        isReady: false,
      }, () => {
        this.getClients(1, false);
      });
    }
  }
  getUserWithoutPagenation = () => {
    axios.get(`${BASE_END_POINT}quickSearch/get?type=SUB-ADMIN`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    }).then(response => {
      console.log(response.data.data)
      this.setState({ users: response.data.data })
    })
      .catch(error => {
        console.log("ALL users ERROR")
        console.log(error.response)
      })
  }
  getCountries = () => {
    axios.get(`${BASE_END_POINT}countries/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ countries: response.data.data })
      })
      .catch(error => {
        console.log("ALL countries ERROR")
        console.log(error.response)
      })
  }
  getAreas = (city) => {
    axios.get(`${BASE_END_POINT}areas/${city}/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ areas: response.data.data })
      })
      .catch(error => {
        console.log("ALL areas ERROR")
        console.log(error.response)
      })
  }
  getCities = (country) => {
    axios.get(`${BASE_END_POINT}countries/${country}/cities/withoutPagenation/get?country=${country}`)
      .then(response => {
        console.log(response.data)
        this.setState({ cities: response.data.data })
      })
      .catch(error => {
        console.log("ALL cities ERROR")
        console.log(error.response)
      })
  }
  getCategory = () => {
    axios.get(`${BASE_END_POINT}categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ categories: response.data.data })
      })
      .catch(error => {
        console.log("ALL categories ERROR")
        console.log(error.response)
      })
  }
  getSubCategory = (category) => {
    axios.get(`${BASE_END_POINT}categories/${category}/sub-categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ subCategories: response.data.data })
      })
      .catch(error => {
        console.log("ALL subCategories ERROR")
        console.log(error.response)
      })
  }

  getClients = (page, refresh) => {
    this.setState({ loading: true })
    let url = `${BASE_END_POINT}clients?page=${page}`
    if (this.props.location.pathname === "/walletClients") {
      url = `${BASE_END_POINT}clients?page=${page}&lockedBy=${this.props.currentUser.user.id}`
    }
    let { lockedBy, country, city, area, contractType, status, search, category, subCategory, user, startDate, endDate } = this.state
    if (refresh !== true) {
      let keysToFilter = { lockedBy, country, city, area, contractType, status, search, category, subCategory, user, startDate, endDate }
      Object.keys(keysToFilter).forEach(key => {
        if (keysToFilter[key] !== null) {
          url += `&${key}=${keysToFilter[key]}`;
        }
      });

    } else {
      this.setState({
        loading: false, lockedBy: null, contractType: null, city: null, area: null, country: null, category: null, subCategory: null,
        status: null, search: null, startDate: null, endDate: null
      })
    }
    axios.get(url, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log("clients   ", response.data)
        let data = response.data.data.map(item => [
          item.id,
          item.clientName ? item.clientName : '',
          item.clientPhone ? item.clientPhone : '',
          item.user ? item.user.fullname : '',
          item.status === "PENDING" ? { type: 'tag', value: allStrings.pending } : item.status === "ON-PROGRESS" ? { type: 'tag', value: allStrings.dealOnProgress } : item.status === "DEAL" ? { type: 'tag', value: allStrings.dealDone } : { type: 'tag', value: allStrings.dealFailed },
          item.isLocked ? { type: 'tag', value: allStrings.yes } : { type: 'tag', value: allStrings.no },
          item.city ? item.city.cityName : "",
          item.subCategory ? item.subCategory.categoryName : "",
          "action"])
        console.log("DATA   ", data)
        this.setState({
          loading: false,
          refresh: false,
          count: response.data.totalCount,
          clients: response.data.data,
          clients2: data,
          page: response.data.page,
          pages: response.data.pageCount,
        })
        sessionStorage.setItem('pageNum', page);
        sessionStorage.setItem('pageName', "CLIENTS");
      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
        this.setState({ loading: false, })
      })
  }
  getClientsWithoutPagenation = (refresh) => {
    let url = `${BASE_END_POINT}clients/withoutPagenation/get?all=true`
    if (this.props.location.pathname === "/walletClients") {
      url = `${BASE_END_POINT}clients/withoutPagenation/get?lockedBy=${this.props.currentUser.user.id}`
    }
    let { lockedBy, country, city, area, contractType, status, search, category, subCategory, user, startDate, endDate } = this.state
    if (refresh !== true) {
      let keysToFilter = { lockedBy, country, city, area, contractType, status, search, category, subCategory, user, startDate, endDate }
      Object.keys(keysToFilter).forEach(key => {
        if (keysToFilter[key] !== null) {
          url += `&${key}=${keysToFilter[key]}`;
        }
      });

    } else {
      this.setState({
        loading: false, lockedBy: null, contractType: null, city: null, area: null, country: null, category: null, subCategory: null,
        status: null, search: null, startDate: null, endDate: null
      })
    }
    axios.get(url, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log("clients   ", response.data)
        csvData = response.data.data.map(item => {
          return {
            ...{ id: item.id },
            ...{ clientName: item.clientName ? item.clientName : '' },
            ...{ clientPhone: item.clientPhone ? "\t" + item.clientPhone : '' },
            ...{ clientCountry: item.clientCountry ? item.clientCountry.countryName : '' },
            ...{ user: item.user ? item.user.fullname : '' },
            ...{ city: item.city ? item.city.cityName : "" },
            ...{ area: item.area ? item.area.areaName : "" },
            ...{ category: item.category ? item.category.categoryName : "" },
            ...{ subCategory: item.subCategory ? item.subCategory.categoryName : "" },
            ...{ contractType: item.contractType ? item.subCategory.contractType : "" },
            ...{ date: moment(item.createdAt).format("dddd D MMMM YYYY hh:mm A") },
          };
        });
        console.log(csvData)
        this.setState({ csvData: csvData, isReady: true })

      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
      })
  }
  delete = (id) => {
    console.log("ID   ", id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}clients/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("Row DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.getClients(this.state.page)
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };
  addNewRecordButton = () => (
    <div style={{ width: '100%' }}>
      <NavLink to="AddClient">
        <Fab
          style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', float: 'left', margin: '50px 30px', width: '150px', height: '40px', borderRadius: '8px' }}
          letiant="extended"
          size="medium"
          color="primary"
          aria-label="add"
        >
          <AddIcon />{allStrings.addNewRecored}
        </Fab>
      </NavLink>
    </div>
  )

  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('CLIENTS')) return <Redirect to='/Home' />
    const title = this.props.location.pathname === "/walletClients" ? allStrings.walletClients : allStrings.Clients;
    return (

      <MDBContainer>
        <MDBRow>
          <MDBCol md="12">
            <div className="screenTable">

              <Table
                title={title}
                icon='contact_phone'

                settings={
                  <div>
                    <i class="fab fa-searchengin searchIcon" onClick={() => this.setState({ showFilter: !this.state.showFilter })}></i>
                    <span
                      style={{ zIndex: '1', position: 'relative', padding: '4px', color: '#659FF1', fontSize: '25px', borderRadius: '50%', top: '4px', cursor: 'pointer' }}
                      onClick={() => { this.getClients(1, true); this.setState({ buildCsv: false }) }}
                      class="material-icons">
                      replay
                    </span>
                    {!this.state.buildCsv &&
                      <img crossorigin="anonymous" alt="" onClick={() => { this.setState({ buildCsv: true }); this.getClientsWithoutPagenation() }}
                        style={{ padding: '0px', position: 'relative', top: '-6px', marginLeft: '5px', cursor: 'pointer' }}
                        src={require('../../assets/images/buildCsv.png')} width="26"></img>
                    }{!this.state.isReady && this.state.buildCsv &&
                      <img crossorigin="anonymous" alt=""
                        style={{ padding: '0px', position: 'relative', top: '-5px', marginLeft: '-15px' }}
                        src={require('../../assets/images/loading.gif')} width="70"></img>
                    }{this.state.isReady && this.state.buildCsv &&
                      <CSVLink
                        data={this.state.csvData}
                        headers={headers}
                        filename={"clients.csv"}
                        style={{ padding: '10px', position: 'relative', top: '-5px' }}
                      >
                        <img alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                      </CSVLink>
                    }
                  </div>

                }
                filter={
                  <div>
                    <div className={this.state.showFilter ? 'showClass' : 'hideClass'}>

                      <MDBRow>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.area}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.area}
                            value={this.state.area}
                            showCheckedStrategy={SHOW_PARENT}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ area: value });

                            }}

                          >
                            {this.state.areas.map(val => (
                              <TreeNode value={val.id} title={this.props.isRTL ? val.areaName_ar : val.areaName_en} key={val.id} />
                            ))}
                          </TreeSelect>
                        </MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.city}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.city}
                            value={this.state.city}
                            showCheckedStrategy={SHOW_PARENT}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ city: value });
                              this.getAreas(value)
                            }}

                          >
                            {this.state.cities.map(val => (
                              <TreeNode value={val.id} title={this.props.isRTL ? val.cityName_ar : val.cityName_en} key={val.id} />
                            ))}
                          </TreeSelect>
                        </MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.country}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.country}
                            value={this.state.country}
                            showCheckedStrategy={SHOW_PARENT}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ country: value });
                              this.getCities(value)
                            }}

                          >
                            {this.state.countries.map(val => (
                              <TreeNode value={val.id} title={this.props.isRTL ? val.countryName_ar : val.countryName_en} key={val.id} />
                            ))}
                          </TreeSelect>
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.subCategory}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.subCategory}
                            value={this.state.subCategory}
                            showCheckedStrategy={SHOW_PARENT}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ subCategory: value });
                            }}

                          >
                            {this.state.subCategories.map(val => (
                              <TreeNode value={val.id} title={this.props.isRTL ? val.categoryName_ar : val.categoryName_en} key={val.id} />
                            ))}
                          </TreeSelect>
                        </MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.category}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.category}
                            value={this.state.category}
                            showCheckedStrategy={SHOW_PARENT}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ category: value });
                              this.getSubCategory(value)
                            }}

                          >
                            {this.state.categories.map(val => (
                              <TreeNode value={val.id} title={this.props.isRTL ? val.categoryName_ar : val.categoryName_en} key={val.id} />
                            ))}
                          </TreeSelect>
                        </MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.contractType}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            value={this.state.contractType}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.contractType}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ contractType: value });
                            }}

                          >
                            <TreeNode value="SALE" title={allStrings.sale} key="SALE" />
                            <TreeNode value="RENT" title={allStrings.rent} key="RENT" />

                          </TreeSelect>
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.employee}</label>
                          <TreeSelect virtual={false}
                            disabled={this.props.currentUser.user.type !== 'ADMIN' ? true : false}
                            showSearch={true}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.employee}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ lockedBy: value });
                            }}

                          >
                            {this.state.users.map(val => (
                              <TreeNode value={val.id} title={val.fullname} key={val.id} />
                            ))}
                          </TreeSelect>
                        </MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label htmlFor="form605" className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.date}</label>
                          <ConfigProvider locale={this.props.isRTL ? locale_ar : locale_en}>
                            <RangePicker format={"YYYY-MM-DD"} placeholder={[allStrings.startDate, allStrings.endDate]} onChange={this.onChange} />
                          </ConfigProvider>
                        </MDBCol>

                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            value={this.state.status}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.status}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ status: value });
                            }}

                          >
                            <TreeNode value="PENDING" title={allStrings.pending} key="PENDING" />
                            <TreeNode value="ON-PROGRESS" title={allStrings.dealOnProgress} key="ON-PROGRESS" />
                            <TreeNode value="FAILED" title={allStrings.dealFailed} key="FAILED" />
                            <TreeNode value="DEAL" title={allStrings.dealDone} key="DEAL" />

                          </TreeSelect>
                        </MDBCol>

                      </MDBRow>
                      <MDBRow>
                        <MDBCol xl="12" lg="12" md="12" sm="12">
                          <div class="md-form">
                            <label htmlFor="form605" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.Search}</label>
                            <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', fontWeight: '300' }} type="text" id="form605" class="form-control"
                              placeholder={allStrings.adsFilterSearch}
                              onChange={(e) => {
                                this.setState({ search: e.target.value })
                              }}
 placeholder="أدخل البيانات..."                            />
                          </div>
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol xl="12" lg="12" md="12" sm="12">
                          <Button style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff', width: '100%', margin: '32px auto' }}
                            onClick={() => { this.getClients(1); this.setState({ buildCsv: false }) }}><SearchOutlined /> {allStrings.Search}</Button>

                        </MDBCol>
                      </MDBRow>

                    </div>
                  </div>
                }
                data={this.state.clients}
                data2={this.state.clients2}
                tableColumns={["#", allStrings.fullname, allStrings.phone, allStrings.owner, allStrings.status, allStrings.locked, allStrings.city, allStrings.type, allStrings.action]} loading={this.state.loading}
                deleteItem={(id) => { this.delete(id) }}
                path='/ClientInfo'
                actionIndex={8}
                enableEdit={false}
                dataCount={this.state.count}
              />
              <PaginationButtons
                page={this.state.page}
                pages={this.state.pages}
                labels={allStrings}
                onPageChange={(newPage) => {
                  this.getClients(newPage);
                  this.setState({ page: newPage });
                }}
              />
              {this.props.location.pathname === "/Clients" && this.addNewRecordButton()}

            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

    );
  }

}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDACCEPTEDatchToProps = {
  ChangeLanguage
}

export default withRouter(
  connect(mapToStateProps, mapDACCEPTEDatchToProps)(clients)
);

